
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(8(561|614|964)|1160|343|4553)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
